jQuery(function ($) {
    $('.text .js-text-toggle').each(function () {
        const $btn = $(this);
        const $list = $btn.closest('.text').find('.text__list');

        $list.hide();

        $btn.on('click keydown', function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();

            const open = $btn.attr('aria-expanded') === 'true';
            $btn.attr('aria-expanded', !open);
            $btn.find('.js-caret').toggleClass('is-open', !open);
            $list.stop(true, true).slideToggle(200);
        });
    });
});
